import React from 'react';

import { OsPrompts, checkForOSPrompts } from 'state/location/routes';
import { IMParticleCtx, useMParticleContext } from 'state/mParticle';

class AutoPromptPermissionWithContext extends React.Component<{
  logEvent: IMParticleCtx['logEvent'];
  logRBIEvent: IMParticleCtx['logRBIEvent'];
}> {
  componentDidMount() {
    checkForOSPrompts(`/OS/${OsPrompts.location}`, this.props.logEvent, this.props.logRBIEvent);
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return null;
  }
}

export const AutoPromptLocationPermission = () => {
  const { logEvent, logRBIEvent } = useMParticleContext();

  return <AutoPromptPermissionWithContext logEvent={logEvent} logRBIEvent={logRBIEvent} />;
};
